import type {FC} from 'react';
import {Box} from '@wellstone-solutions/web';
import {ListCell} from 'modules/datagrid';
import {useStores} from 'hooks/useStores';

interface GroupListCellProps {
  groupIds: Array<string>;
}

export const GroupListCell: FC<GroupListCellProps> = ({groupIds}) => {
  const {groupStore} = useStores();
  const items = groupIds.map((id) => groupStore.getGroupById(id).name);
  return items.length > 0 ? <ListCell items={items} /> : <Box>No Groups</Box>;
};
